// SSO 프리셋 — 자격증명이 같은 고객사끼리 공유
const SSO_PRESETS = {
	METANET_AZURE: {
		SSO_PROVIDER: 'AZURE',
		SSO_PROTOCOL: 'OAuth2',
		AZURE_CLIENT_ID: 'aba7eb4b-68b7-4d3d-857e-ded2e63fcae1',
		AZURE_TENANT: '9e00aa79-8db6-4d36-a892-747eec99934d',
		REGISTRATION_ID: 'azure-client-metanet',
	},
	GASENTEC_AZURE: {
		SSO_PROVIDER: 'AZURE',
		SSO_PROTOCOL: 'OAuth2',
		AZURE_CLIENT_ID: '59f55b22-3a35-463c-9f99-91fd627c30c8',
		AZURE_TENANT: 'ae4ea25f-c86d-4c94-b4ed-0f8add35ae30',
		REGISTRATION_ID: 'azure-client-gasntec',
	},
};

// 전체 환경/고객사 목록 — ssoPreset 있으면 SSO 사용, 없으면 미사용
// AZURE_REDIRECT_URI는 window.location.origin 기반으로 자동 생성
const HOSTS = {
	metanet:     { ssoPreset: 'METANET_AZURE' },
	mtkr:        {},
	rayno:       {},
	chemtronics: {},
	ewits:       {},
	beyondi:     {},
	jei3:        {},
	gasentec:    { ssoPreset: 'GASENTEC_AZURE' },
	uat:         { ssoPreset: 'METANET_AZURE' },
	local:       { ssoPreset: 'GASENTEC_AZURE' },
};

let host = process.env.REACT_APP_ENV;
if (window.location.hostname === 'localhost') {
	host = 'local';
} else if (host == 'saas-prod') {
	host = window.location.hostname.split('.')[0];
}

// HOSTS에 없는 고객사도 hostname 기반으로 동작 (hostOverrides 없이 env 기본값 사용)
const hostOverrides = Object.fromEntries(
	Object.entries(HOSTS).map(([h, cfg]) => [
		h,
		cfg.ssoPreset ? {
			...SSO_PRESETS[cfg.ssoPreset],
			AZURE_REDIRECT_URI: `${window.location.origin}/auth/azure/callback`,
		} : {},
	])
);

// FCM 설정
let domainGroup = 'pinat';
const FIREBASE_APP = {
	pinat: {
		apiKey: 'AIzaSyCdo8Fc5y97oQ3FN7VIWk0-SlHQKMnjuXk',
		authDomain: 'tna-fcm.firebaseapp.com',
		projectId: 'tna-fcm',
		storageBucket: 'tna-fcm.firebasestorage.app',
		messagingSenderId: '96167652953',
		appId: '1:96167652953:web:af882701ea1762b3278b48',
		measurementId: 'G-M3B66LTEPW',
	},
	pinat2: {
		apiKey: 'AIzaSyCUXtTbRCmgvchMjIAVnoMpFB6NaMgK3SI',
		authDomain: 'pinat-eb6f2.firebaseapp.com',
		projectId: 'pinat-eb6f2',
		storageBucket: 'pinat-eb6f2.appspot.com',
		messagingSenderId: '2596862216',
		appId: '1:2596862216:web:39378c9b0529e3fba9d4bd',
		measurementId: 'G-2XR62C8FND',
	},
	ls: {
		apiKey: 'AIzaSyATWO2lLlMRNDzz376c6l1PfhVb4xKA4cg',
		authDomain: 'metatime-bad42.firebaseapp.com',
		projectId: 'metatime-bad42',
		storageBucket: 'metatime-bad42.appspot.com',
		messagingSenderId: '649124742809',
		appId: '1:649124742809:web:3981c6e0e1b34f6cde5a08',
		measurementId: 'G-K4JY0JTGS8',
	},
	gaon: {
		apiKey: 'AIzaSyATWO2lLlMRNDzz376c6l1PfhVb4xKA4cg',
		authDomain: 'metatime-bad42.firebaseapp.com',
		projectId: 'metatime-bad42',
		storageBucket: 'metatime-bad42.appspot.com',
		messagingSenderId: '649124742809',
		appId: '1:649124742809:web:3981c6e0e1b34f6cde5a08',
		measurementId: 'G-K4JY0JTGS8',
	},
	evk: {
		apiKey: 'AIzaSyATWO2lLlMRNDzz376c6l1PfhVb4xKA4cg',
		authDomain: 'metatime-bad42.firebaseapp.com',
		projectId: 'metatime-bad42',
		storageBucket: 'metatime-bad42.appspot.com',
		messagingSenderId: '649124742809',
		appId: '1:649124742809:web:3981c6e0e1b34f6cde5a08',
		measurementId: 'G-K4JY0JTGS8',
	},
};

const exceptCompList = ['5000'];

const config = {
	// 로컬, 개발서버, 운영서버의 설정을 모두 여기서 지정
	[host]: {
		CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
		API_URL: process.env.REACT_APP_API_URL.replace('{origin}', window.location.origin),
		KAKAO_API_KEY: process.env.REACT_APP_KAKAO_API_KEY,
		REACT_APP_BUSINESS_REGISTRATION_INFORMATION_API_KEY: process.env.REACT_APP_BUSINESS_REGISTRATION_INFORMATION_API_KEY,
		appVersion: process.env.REACT_APP_APP_VERSION,
		buildVersion: process.env.REACT_APP_BUILD_VERSION,
		title: process.env.REACT_APP_TITLE,
		domainGroup: process.env.REACT_APP_DOMAIN_GROUP,
		FIREBASE_CONFIG: FIREBASE_APP[domainGroup],
		exceptCompList,
		host,
		GG_KEY: process.env.REACT_APP_GG_KEY,
		CHANNEL_IO_KEY: process.env.REACT_APP_CHANNEL_IO_KEY,
		...(hostOverrides[host] || {}),
	}
	// qa: {
	//   API_URL: "https://qaapi.pinat.co.kr/api/v1",
	//   CLIENT_ID: 'kr.co.pinat',
	//   KAKAO_API_KEY: "61ebdc909cc9f97b4a24abc1d72aa4bb",
	//   REACT_APP_BUSINESS_REGISTRATION_INFORMATION_API_KEY: "f2OpoyBkYHmpFj9mTkmaCW8l%2B8qy51ejekkAN8OYspXTuyQs%2FT%2BJsvNtgjzDtsSvWTIWnF%2Bn1s6OtoBQNZvDTg%3D%3D",
	//   appVersion,
	//   buildVersion,
	//   title,
	//   domainGroup,
	//   FIREBASE_CONFIG: FIREBASE_APP[domainGroup],
	//   exceptCompList,
	//   host
	// },
	// prod: {
	//   API_URL: "https://api.pinat.co.kr/api/v1",
	//   CLIENT_ID: 'kr.co.pinat',
	//   KAKAO_API_KEY: "61ebdc909cc9f97b4a24abc1d72aa4bb",
	//   REACT_APP_BUSINESS_REGISTRATION_INFORMATION_API_KEY: "f2OpoyBkYHmpFj9mTkmaCW8l%2B8qy51ejekkAN8OYspXTuyQs%2FT%2BJsvNtgjzDtsSvWTIWnF%2Bn1s6OtoBQNZvDTg%3D%3D",
	//   appVersion,
	//   buildVersion,
	//   title,
	//   domainGroup,
	//   FIREBASE_CONFIG: FIREBASE_APP[domainGroup],
	//   exceptCompList,
	//   host
	// },
	// lsdev: {
	//   API_URL: "https://"+window.location.host+"/api/v1",
	//   CLIENT_ID: 'kr.co.pinat',
	//   KAKAO_API_KEY: "942cc45b4238be70ee518db7de377a25",
	//   REACT_APP_BUSINESS_REGISTRATION_INFORMATION_API_KEY: "f2OpoyBkYHmpFj9mTkmaCW8l%2B8qy51ejekkAN8OYspXTuyQs%2FT%2BJsvNtgjzDtsSvWTIWnF%2Bn1s6OtoBQNZvDTg%3D%3D",
	//   AZURE_CLIENT_ID: '44abf638-f2f8-4e17-8bb3-6112b7835287',
	//   AZURE_TENANT: 'e3ac560c-55aa-49d9-b1e6-9b5acb802bfa',
	//   AZURE_REDIRECT_URI: '/auth/azure/callback',
	//   appVersion,
	//   buildVersion,
	//   title,
	//   domainGroup,
	//   FIREBASE_CONFIG: FIREBASE_APP[domainGroup],
	//   exceptCompList,
	//   host
	// },
	// lsprod: {
	//   API_URL: "https://"+window.location.host+"/api/v1",
	//   CLIENT_ID: 'kr.co.pinat',
	//   KAKAO_API_KEY: "942cc45b4238be70ee518db7de377a25",
	//   REACT_APP_BUSINESS_REGISTRATION_INFORMATION_API_KEY: "f2OpoyBkYHmpFj9mTkmaCW8l%2B8qy51ejekkAN8OYspXTuyQs%2FT%2BJsvNtgjzDtsSvWTIWnF%2Bn1s6OtoBQNZvDTg%3D%3D",
	//   AZURE_CLIENT_ID: 'ecce71ba-5a26-40f6-af39-7baef17f57d9',
	//   AZURE_TENANT: 'e3ac560c-55aa-49d9-b1e6-9b5acb802bfa',
	//   AZURE_REDIRECT_URI: '/auth/azure/callback',
	//   appVersion,
	//   buildVersion,
	//   title,
	//   domainGroup,
	//   FIREBASE_CONFIG: FIREBASE_APP[domainGroup],
	//   exceptCompList,
	//   host
	// },
};

export default config[host];
